<app-top-bar
	[transportId]="store.transport()?.id"
	[module]="TransportModule.LIST"
	[side]="store.transport()?.side ?? TransportSide.DEPARTURE"
	[buttonsDisabled]="store.transportAction() === TransportAction.ADD"
	[transportName]="store.transport()?.name"
	[kind]="store.transport()?.kind"
	[transportsToLinkNames]="store.transportsToLinkNames()"
>
</app-top-bar>

<mat-tab-group>
	<mat-tab>
		<ng-template mat-tab-label>Docelowa</ng-template>
		<app-transport-list-table
			[tabType]="ListTabType.TARGET_LIST"
			[columns]="targetListColumns"
			[transportSide]="store.transport()?.side ?? TransportSide.DEPARTURE"
			[data]="store.offerTransportList()"
		></app-transport-list-table>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>Paszportowa</ng-template>
		<app-transport-list-table
			[tabType]="ListTabType.PASSPORT_LIST"
			[columns]="passportListColumns"
			[transportSide]="store.transport()?.side ?? TransportSide.DEPARTURE"
			[data]="store.offerTransportList()"
		>
		</app-transport-list-table>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>Opłaty</ng-template>
		<app-transport-list-table
			[tabType]="ListTabType.FEE"
			[columns]="feeColumns"
			[transportSide]="store.transport()?.side ?? TransportSide.DEPARTURE"
			[data]="store.offerTransportList()"
		>
		</app-transport-list-table>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>TGS</ng-template>
		<app-transport-list-table
			[tabType]="ListTabType.TGS"
			[columns]="tgsColumns"
			[transportSide]="store.transport()?.side ?? TransportSide.DEPARTURE"
			[data]="store.offerTransportList()"
		>
		</app-transport-list-table>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>SMS</ng-template>
		<app-transport-list-table
			[tabType]="ListTabType.SMS"
			[columns]="smsColumns"
			[transportSide]="store.transport()?.side ?? TransportSide.DEPARTURE"
			[data]="store.offerTransportList()"
			(refreshView)="store.triggerRefresh()"
		>
		</app-transport-list-table>
	</mat-tab>
</mat-tab-group>
